import { Navigate } from 'react-router-dom';
import { PageHeader } from '@/components/ui/PageHeader';
import { LoadingState } from '@/components/ui/StateViews';
import { useOffer } from '@/features/access/PlanOffer';
import { CheckoutProducts } from './CheckoutProducts';

/**
 * Тарифы и покупка внутри Creativitas — сюда ведут кнопки кабинета и лендинг
 * Tilda (docs/payments/ROBOKASSA_DIRECT.md, п. 8). Пока прямая оплата не
 * включена, страницы нет: покупка идёт прежним путём через Tilda.
 */
export function TariffsPage() {
  const offer = useOffer();
  if (offer.isLoading) return <LoadingState />;
  if (!offer.data?.direct) return <Navigate to="/dashboard" replace />;
  return (
    <>
      <PageHeader
        eyebrow="Оплата"
        title="Тарифы"
        description="Лайт открывает материалы тарифа Лайт, Про — всё из Лайт и материалы Про. Повторная покупка продлевает тариф от даты окончания."
      />
      {/* Отдельные материалы продаются со своих страниц и по платёжным ссылкам, здесь — тарифы и игры. */}
      <CheckoutProducts filter={(product) => product.grantType !== 'content_access'} />
    </>
  );
}
